import React, { useContext } from 'react';
import { Context } from "../../components/contexts/AppContext";
import { useNavigate, useParams } from 'react-router-dom';

function PhotoButton() {

     const { value } = useContext(Context);  
  const [appState, setAppState] = value; 
   const isGalleryId = (input) => /^[0-9a-fA-F]{24}$/.test(input);
    const { galleryId } = useParams();
   const navigate = useNavigate();

 const openPhotoGallery = () => {

  // window.history.pushState(
  //   { photoGallery: true },
  //   ""
  // );

  // setAppState((prevState) => {
  //   return {
  //     ...prevState,
  //     modalData: {
  //       ...prevState.modalData,
  //       type: "PhotoThumbnailModal",
  //       isOpen: true,
  //     },
  //   };
   // });
    navigate(
        `/${galleryId}/photos`
      );
};
  return (
 <div id="PhotoButton" >
  
  {/* Desktop Button */}
  {/* <button
    onClick={openPhotoGallery}
    className="hidden sm:flex px-4 py-2 text-sm font-light rounded-full items-center bg-gray-800 text-white hover:bg-gray-700 transition duration-300"
  >
    <div className="md:text-sm font-medium">Photos</div>
  </button> */}

  {/* Mobile Round Icon Button */}
  <button
    onClick={openPhotoGallery}
    className="flex  items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-gray-900 text-white hover:bg-gray-700 transition duration-300"
  >
    {/* Image Icon (SVG) */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-7 h-7"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M21 19V5a2 2 0 0 0-2-2H5C3.9 3 3 3.9 3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
        </svg>
     
  </button>
  
</div>

  );
}

export default PhotoButton;
